export default function () {
  const widgetName = 'multiScheduleFeature';
  const widgetOpts = multiScheduleFeatureOpts;

  $(`#${widgetName}`).append('<div class="multiFeatureContent"><h1><span>upcoming</span> events</h1></div>');
  setTimeout(function () {
    $(".all-events-btn").wrap("<div class='events-btn-wrap'></div>");
  }, 2000);
  $(`#${widgetName}`).MultiScheduleFeature({
    scriptPath: widgetOpts.scriptPath
    , currentWidgetModuleItemID: widgetOpts.WidgetModuleDataItemID
    , detectIpad: IPADDETECTED
    // options
    , detectIpad: IPADDETECTED
    // options
    , allEventsLink: true
    , allEventsLinkText: 'View All Events'
    , hasImages: false
    , imageBackground: false
    , lazyLoadImages: true
    , buyNowButton: { visible: false, text: '>' }
    , moreButton: { visible: false, text: 'MORE' }
    , maxItemsVisible: 5
    , isResponsive: false
    , hasDescription: false
    , textContainer: true
    , link: 'all' //options are 'all', 'text', 'image', 'imageAndText', or ''
    , attributeOrder: {
      1: 'image',
      2: 'date',
      3: 'title',
      4: 'description',
      5: 'buttons'
    }
    , multiFeatureLoaded: function (data) {
      // console.log(data);
      // use function below if "more" text needs to appear at end of description text

      $('#multiScheduleFeature .featureItem').each(function() { 
        var eventDate = $(this).find($('span.featureItemDate'));
        var dateString = eventDate.text().trim(); // Trim to remove any leading or trailing spaces
    
        // Remove the year after the comma, if present
        var dateParts = dateString.split(',');
        var dateWithoutYear = dateParts[0];
        var itemtittle = $(this).find('.featureItemTitle');
    
        // Set the modified date string
        eventDate.text(dateWithoutYear);
        var characterLimitTitle = 41;
        var itemTitleText = itemtittle.text();
        if (itemTitleText.length > characterLimitTitle) {
            var trimmedTextTitle = itemTitleText.substring(0, characterLimitTitle);
            itemtittle.text(trimmedTextTitle);
        }
    
    });
    
    }
  });

};

